import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useRef, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/styles.css";
import galleryStaticData from "../../constant/galleryStaticData";

const Gallery = () => {
  const scrollRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const scrollByCard = (direction) => {
    if (scrollRef.current) {
      // Get first card width (including margin if any)
      const card = scrollRef.current.querySelector(".gallery-card");
      if (card) {
        const cardWidth = card.offsetWidth + 24;
        scrollRef.current.scrollBy({
          left: direction === "left" ? -cardWidth : cardWidth,
          behavior: "smooth",
        });
      }
    }
  };

  const openImage = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className="gallery-container">
      <div className="gallery-header">
        <h2 className="gallery-heading">Gallery</h2>
        {/* <button className="view-all-btn">View All</button> */}
      </div>

      <div className="gallery-wrapper">
        <div className="gallery-cards" ref={scrollRef}>
          {galleryStaticData.map((item, index) => (
            <div
              className="gallery-card"
              key={item.id}
              onClick={() => openImage(index)}
            >
              <img src={item.image} alt="gallery" className="gallery-img" />
            </div>
          ))}
        </div>

        {/* Both buttons together below on small screens */}
        <div className="gallery-buttons">
          <button
            className="scroll-btn left"
            onClick={() => scrollByCard("left")}
          >
            <KeyboardArrowLeftIcon />
          </button>
          <button
            className="scroll-btn right"
            onClick={() => scrollByCard("right")}
          >
            <KeyboardArrowRightIcon />
          </button>
        </div>
      </div>

      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          index={photoIndex}
          slides={galleryStaticData.map((item) => ({ src: item.image }))}
          plugins={[Captions, Thumbnails]}
          on={{
            slideChange: (newIndex) => setPhotoIndex(newIndex),
          }}
        />
      )}
    </div>
  );
};

export default Gallery;
